import { useState, useEffect } from "react";
import moment from "moment-timezone";
import { useTimezone } from "../../../context/TimezoneContext";

export const useRelativeTime = (dateInput: Date | string): string => {
  const { timezone } = useTimezone();
  const [relativeTime, setRelativeTime] = useState("");

  useEffect(() => {
    const updateRelativeTime = () => {
      const time = moment.utc(dateInput).tz(timezone);
      setRelativeTime(time.fromNow());
    };

    updateRelativeTime();
    const interval = setInterval(updateRelativeTime, 60000);
    return () => clearInterval(interval);
  }, [dateInput, timezone]);

  return relativeTime;
};
